import { BaseSystem, SystemOperationDefinition, Zed, ZedEntity, World } from '@modules/core';

import { Camera, EngineView } from '@babylonjs/core';
import { BabylonjsModule } from '../BabylonjsModule';

export type CanvasEntity = {
  Canvas?: ZedEntity['Canvas'] & {
    camera?: Camera | Camera[];
    input?: true;
    clearBeforeCopy?: true;
    targetFps?: number;
  };
  EngineView?: EngineView;
};

type Entity = ZedEntity & CanvasEntity;

export class CanvasSystem implements BaseSystem {
  static readonly INJECTABLE_TOKEN = Symbol.for('CanvasSystem');

  private readonly world;
  private readonly withoutEngineView;
  private readonly withEngineView;
  private readonly withoutCanvas;

  private readonly engine;
  private readonly scene;

  constructor({
    [Zed.WORLD_TOKEN]: world,
    [BabylonjsModule.INJECTABLE_TOKEN]: babylonjs,
  }: {
    [Zed.WORLD_TOKEN]: World<Entity>;
    [BabylonjsModule.INJECTABLE_TOKEN]: BabylonjsModule;
  }) {
    this.world = world;
    this.withoutEngineView = world.with('Canvas').without('EngineView');
    this.withEngineView = world.with('Canvas').with('EngineView');
    this.withoutCanvas = world.with('EngineView').without('Canvas');

    // 외부에서 entity를 제거할 경우가 있어서 이벤트를 등록
    this.withEngineView.onEntityRemoved.subscribe((entity) => {
      this.engine.unRegisterView(entity.EngineView.target);
    });

    this.engine = babylonjs.engine;
    this.scene = babylonjs.scene;
  }

  private render = () => {
    for (const entity of this.withoutCanvas) {
      this.world.removeComponent(entity, 'EngineView');
    }

    for (const entity of this.withoutEngineView) {
      const { element, camera, scale, input, clearBeforeCopy } = entity.Canvas;
      const view = this.engine.registerView(element, camera, clearBeforeCopy);
      if (input) {
        // FIXME: there was severe performance issue with this in safari
        // this.scene.detachControl();
        this.engine.inputElement = element;
        // this.scene.attachControl();

        // const activeCameras = camera
        //   ? Array.isArray(camera)
        //     ? camera
        //     : [camera]
        //   : this.scene.activeCameras?.length ?? 0 > 0
        //     ? this.scene.activeCameras
        //     : this.scene.activeCamera
        //       ? [this.scene.activeCamera]
        //       : [];

        // activeCameras?.forEach((camera) => {
        //   camera.detachControl();
        //   camera.attachControl();
        // });
      }
      if (scale && scale !== 1) {
        view.customResize = (canvas) => {
          const hardwareScale = this.engine.getHardwareScalingLevel();
          const finalScale = Math.min(window.devicePixelRatio ?? Number.POSITIVE_INFINITY, scale / hardwareScale);
          canvas.width = canvas.clientWidth * finalScale;
          canvas.height = canvas.clientHeight * finalScale;
          this.engine.setSize(canvas.width, canvas.height);
        };
      }
      this.world.addComponent(entity, 'EngineView', view);
    }
  };

  operations: readonly SystemOperationDefinition[] = [
    {
      run: this.render,
    },
  ];
}
